import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRReaderComponent } from './qr-reader.component';

@NgModule({
    declarations: [QRReaderComponent],
    exports: [QRReaderComponent],
    imports: [CommonModule],
})
export class QRReaderModule {}
